(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/fractiongames/assets/react/components/games.js') >= 0) return;  svs.modules.push('/components/numbergames/fractiongames/assets/react/components/games.js');

'use strict';

var _svs$numbergames$frac2;
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useMemo = _React.useMemo,
  useState = _React.useState,
  useCallback = _React.useCallback,
  useEffect = _React.useEffect;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector,
  useDispatch = _ReactRedux.useDispatch;
const Icon = svs.ui.ReactIcon;
const ErrorBoundary = svs.components.errorBoundary.ErrorBoundary;
const ReservedGamesMessage = svs.numbergames.fractiongames.components.ReservedGamesMessage;
const _svs$numbergames$frac = svs.numbergames.fractiongames.components.gamecard,
  GameCard = _svs$numbergames$frac.GameCard,
  GameCardError = _svs$numbergames$frac.GameCardError;
const payGame = svs.numbergames.fractiongames.redux.thunks.payGame;
const hasReservedGames = (_svs$numbergames$frac2 = svs.numbergames.fractiongames.data.reservedgames) === null || _svs$numbergames$frac2 === void 0 ? void 0 : _svs$numbergames$frac2.hasReservedGames;
const createSortedContainersSelector = svs.numbergames.fractiongames.redux.slices.containers.selectors.createSortedContainersSelector;
const _svs$numbergames$frac3 = svs.numbergames.fractiongames.contexts,
  CampaignContextProvider = _svs$numbergames$frac3.CampaignContextProvider,
  ContainerContextProvider = _svs$numbergames$frac3.ContainerContextProvider;
const Games = _ref => {
  let productFilter = _ref.productFilter;
  const selectContainerIds = useMemo(() => createSortedContainersSelector(productFilter), [productFilter]);
  const containerIds = useSelector(selectContainerIds);
  const _useState = useState(hasReservedGames),
    _useState2 = _slicedToArray(_useState, 2),
    hasReserved = _useState2[0],
    setHasReserved = _useState2[1];
  const dispatch = useDispatch();
  const handlePayEvent = useCallback(containerId => {
    dispatch(payGame(containerId, () => setHasReserved(true)));
  }, [dispatch]);
  useEffect(() => {
    if (svs.utils.paramHandler.get({
      key: 'containerId'
    }).value && !svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
      svs.utils.paramHandler.remove({
        key: 'containerId'
      });
    }
    const containerIdParam = svs.utils.paramHandler.get({
      key: 'containerId'
    });
    if (containerIdParam) {
      const containerId = containerIds.find(containerId => containerId === parseInt(containerIdParam.value, 10));
      if (containerId) {
        handlePayEvent(containerId);
      }
      svs.utils.paramHandler.remove({
        key: 'containerId'
      });
    }
  }, [containerIds, handlePayEvent]);
  if (!containerIds.length) {
    return React.createElement("p", {
      className: "ng-fg-message"
    }, React.createElement(Icon, {
      size: "500",
      icon: "exclamation-sign"
    }), " Andelsspel kan inte visas.");
  }
  return React.createElement(React.Fragment, null, hasReserved && React.createElement(ReservedGamesMessage, null), React.createElement("div", {
    className: "ng-fg-games-container"
  }, React.createElement(CampaignContextProvider, null, containerIds.map(containerId => React.createElement(ContainerContextProvider, {
    key: containerId,
    containerId: containerId
  }, React.createElement(ErrorBoundary, {
    fallback: () => React.createElement(GameCardError, null)
  }, React.createElement(GameCard, {
    onPayEvent: handlePayEvent
  })))))));
};
svs.numbergames.fractiongames.components.Games = Games;

 })(window);